import type { Lang } from '../enums.ts';
import { en } from './en.ts';
import { ru } from './ru.ts';
import type { MessageKey, Messages } from './types.ts';
import { uz } from './uz.ts';

export type { MessageKey, Messages };

export const messages: Record<Lang, Messages> = { uz, ru, en };

const pluralRules: Partial<Record<Lang, Intl.PluralRules>> = {};
/** Index into `one|few|many` (ru) or `one|other` (en); Uzbek nouns don't inflect after numbers. */
function pluralIndex(lang: Lang, n: number): number {
  const rules = (pluralRules[lang] ??= new Intl.PluralRules(lang));
  const category = rules.select(n);
  if (lang === 'ru') return category === 'one' ? 0 : category === 'few' ? 1 : 2;
  return category === 'one' ? 0 : 1;
}

/**
 * Translates a key. `{name}` is replaced by `params.name`;
 * `{count:сказка|сказки|сказок}` picks the plural form for `params.count`.
 * Unknown placeholders are left as is.
 */
export function t(lang: Lang, key: MessageKey, params?: Record<string, string | number>): string {
  const template = messages[lang][key];
  if (!params) return template;
  return template.replace(/\{(\w+)(?::([^}]+))?\}/g, (whole, name: string, forms?: string) => {
    if (!(name in params)) return whole;
    const value = params[name];
    if (forms === undefined) return String(value);
    const options = forms.split('|');
    const form = options[Math.min(pluralIndex(lang, Number(value)), options.length - 1)];
    return form ?? whole;
  });
}
